import * as types from './actionTypes';

import axios from 'axios';
// import * as config from '../config/config';
import { beginAjaxCall} from "./ajaxStatusActions";
export const sendForm = (data) => {


    return (dispatch,getState) => {
        dispatch(beginAjaxCall());
        console.log(data);

        let formData = new FormData()

        for (var key in data) {
            if (key !== 'uploadfile') {
                formData.append(key, data[key]);
            }

        }
        if(data.uploadfile){
            formData.append('uploadfile', data.uploadfile[0]);
        }



        // console.log(data.uploadfile[0]);

        axios.post(getState().config.postUrl + '/api/inscription-store', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response) {

                if (response.status === 200) {
                    dispatch({type: types.SUBMIT_FORM_SUCCESS, success: 1});
                } else {
                    alert('Algo salío mal, intentalo nuevamente más tarde.');
                }

            })
            .catch(function (error) {
                console.log(error);
            });

    }
}


// WEBPACK FOOTER //
// ./src/actions/formActions.js